<template>
  <div class="attend-page">
    <exam-header :can-click-logo="true"></exam-header>

    <div class="page-content" v-if="inited">
      <header class="steps-header" v-if="hasApplication || hasAgreed">
        <div
          v-for="(item, index) in steps"
          :key="index"
          :class="[
            'step',
            index <= currentStep ? 'complete' : '',
            index === currentStep ? 'active' : '',
          ]"
        >
          <div class="step-iconWrap">
            <img
              src="https://pandapub.nosdn.127.net/tmp1763002681_ltnon6bsdwqvdloznivmoa%3D%3D_2_1762999081_0.png"
              class="step-icon"
            />
          </div>
          <span>{{ item }}</span>
        </div>
      </header>

      <!-- 未申请状态 -->
      <div v-if="!hasApplication" class="application-form-container">
        <school-application-form
          ref="applicationForm"
          :loading.sync="isLoading"
          :has-agreed.sync="hasAgreed"
          @submit="handleFormSubmit"
          @cancel="handleBack"
        />
      </div>

      <!-- 已申请状态 -->
      <div v-else class="application-status-container">
        <div class="status-header">
          <div class="status-icon" v-if="statusImage">
            <img :src="statusImage" />
          </div>
          <h1 class="status-title">{{ statusTitle }}</h1>
          <p class="status-desc">{{ statusDesc }}</p>
        </div>

        <div class="file-uploadWrap" v-if="applicationStatus === 1">
          <file-upload
            templateUrl="https://resource.du.youdao.com/%E4%B8%98%E7%8F%AD%E6%8A%A5%E5%90%8D%E6%A8%A1%E6%9D%BF.xlsx"
            templateName="填写模版"
            :required="true"
            label="上传需要生成的账号信息"
            labelTip="请下载模板进行账号信息填写"
            :limit="1"
            :max-size="20"
            ref="uploadFile"
            />
        </div>

        <div class="status-actions">
          <div v-if="applicationStatus===1"
            class="button primary-btn"
            @click="handleFileSubmit"
          >
            确认提交
          </div>
          <div
            v-if="canReapply"
            class="button primary-btn"
            @click="handleReapply"
          >
            重新申请
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
  import ExamHeader from '@/components/examHeader.vue';
  import PageFooter from '@/components/PageFooter.vue';
  import FileUpload from '@/components/fileUpload.vue';
  import SchoolApplicationForm from '@/components/schoolApplicationForm.vue';
  import {
    getSchoolApplicationStatus,
    saveSchoolApplication,
    uploadApplicationUser,
  } from '@/api/attend';


  export default {
    name: 'AttendPage',
    components: { ExamHeader, SchoolApplicationForm, FileUpload, PageFooter },
    data() {
      return {
        inited: false,
        isLoading: false,
        hasApplication: false,
        // 0：已提交申请，待审核
        // 1：初审通过
        // 2：初审不通过
        // 3: 复审待审核
        // 4: 复审通过
        // 5: 复审不通过
        applicationStatus: -1,
        application: null,
        steps: ['提交成功', '正在审核', '初审结果', '材料审核', '最终结果'],
        currentStep: 0,
        hasAgreed: false,
      };
    },
    computed: {
      statusTitle() {
        const statusMap = {
          0: '申请正在审核中...',
          1: '恭喜，您的申请已通过！',
          2: '很抱歉，您的申请暂未通过！',
          3: '材料正在审核中...',
          4: '恭喜，您提交的材料审核已通过！',
          5: '很抱歉，您的材料未通过审核！',
        };
        return statusMap[this.applicationStatus] || '申请状态';
      },
      statusDesc() {
        const statusMap = {
          0: '审核预计7个工作日内完成，敬请耐心等待。审核结果也会通过邮件\r\n通知您，请留意近期邮件查收和官网状态~',
          1: '详情请查看邮件！请您通过下方入口上传需要开通的教师和学生账号信息\r\n· 教师账号：可参与学生竞赛试卷的批改工作\r\n· 学生账号：可参加竞赛系统的在线考试',
          2: '详情请查看邮件。您可重新提交申请，我们将尽快为您处理。如需了解详情，可邮件联系：\r\nzhaominli@corp.netease.com（邮件命名格式为：【丘班申请】学校名称+申请咨询）',
          3: '材料审核预计8个工作日内完成，敬请耐心等待。审核结果也会\r\n通过邮件通知您，请留意近期邮件查收和官网状态~',
          4: '详情请查看邮件！现已为材料内的教师、学生开通系统登录权限，教师可登录系统开展试卷\r\n批改工作，学生可登录系统参与在线考试。\r\n如前期无运营老师添加过您，请您及时添加运营老师专属微信：Sabrina_Min，申请添加时\r\n请备注：【丘班系统】学校名称 + 姓名',
          5: '详情请查看邮件。您可重新提交申请，我们将尽快为您处理。如需了解详情，可邮件联系：\r\nzhaominli@corp.netease.com（邮件命名格式为：【丘班申请】学校名称+申请咨询）',
        };
        return statusMap[this.applicationStatus] || '';
      },
      statusImage() {
        const status = this.applicationStatus;
        if ([0, 3].includes(status)) {
          return require('../common/images/img_apply_waiting.png');
        } else if ([1, 4].includes(status)) {
          return require('../common/images/img_apply_pass.png');
        } else if ([2, 5].includes(status)) {
          return require('../common/images/img_apply_deny.png');
        }
        return '';
      },
      canReapply() {
        return this.applicationStatus === 2 || this.applicationStatus === 5;
      },
    },
    created() {
      this.loadApplicationStatus();
    },
    methods: {
      async loadApplicationStatus() {
        try {
          const res = await getSchoolApplicationStatus();
          if (res.code === 200) {
            if (res.body?.application) {
              this.hasApplication = true;
              this.application = res.body.application;
              this.applicationStatus = res.body.application.status;
              switch (this.applicationStatus) {
                case 0:
                  this.currentStep = 1;
                  break;
                case 1:
                case 2:
                  this.currentStep = 2;
                  break;
                case 3:
                  this.currentStep = 3;
                  break;
                case 4:
                case 5:
                  this.currentStep = 4;
                  break;
                default:
                  this.currentStep = 0;
              }
            } else {
              this.hasApplication = false;
              this.applicationStatus = -1;
            }
          }
        } catch (error) {
          console.error('获取申请状态失败', error);
        } finally {
          this.inited = true;
        }
      },
      async handleFormSubmit(formData) {
        this.isLoading = true;
        try {

          const res = await saveSchoolApplication(formData);
          this.$message.success('提交成功');
          // 重新加载状态
          await this.loadApplicationStatus();
        } catch (error) {
          console.error('提交申请失败', error);
          this.$message.error(error?.message || '提交失败，请重试');
        } finally {
          this.isLoading = false;
        }
      },
      handleReapply() {
        // 重置表单，显示申请表单
        this.hasApplication = false;
        this.applicationStatus = -1;
        this.currentStep = 0;
      },
      handleBack() {
        this.$router.back();
      },
      handleFileSubmit() {
        const file = this.$refs.uploadFile.getFile();
        if (!file) {
          this.$message.error('请先上传文件');
          return;
        }
        const formData = new FormData();
        formData.append('file', file);
        formData.append('id', this.application.id);
        uploadApplicationUser(formData).then(res => {
          if (res.code === 200) {
            this.$message.success('文件上传成功');
            // 重新加载状态
            this.loadApplicationStatus();
          } else {
            throw new Error(res.message || '文件上传失败');
          }
        }).catch((err) => {
          this.$message.error(err.message || '文件上传失败');
        });
      }
    },
  };
</script>

<style scoped lang="less">
  .attend-page {
    box-sizing: border-box;
    min-height: 100vh;
    padding-top: 72px;
    // padding-bottom: 48px;
    background: #ede4da;
  }

  .page-content {
    width: 1200px;
    margin: 25px auto 0;
    min-height: calc(100vh - 145px);
    margin-bottom: 48px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .steps-header {
      display: flex;
      justify-content: center;
      align-items: stretch;
      height: 54px;
      background: #f7f8fa;
      margin-top: 28px;
      // margin-bottom: 40px;
      width: 1040px;
      color: #000000e5;
      font-size: 18px;
      font-weight: 500;
      .step {
        position: relative;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .step-iconWrap {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          border-radius: 50%;
          background: #c9cdd4;
          padding: 0 6px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &-icon {
          width: 100%;
        }
        &.complete {
          background: #f7f1e6;
          .step-iconWrap {
            background: #bd9f68;
          }
        }
        &.active:not(:last-child) {
          &::after {
            content: '';
            position: absolute;
            right: -20px;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-top: 27px solid transparent;
            border-bottom: 27px solid transparent;
            border-left: 20px solid #f7f1e6;
          }
        }
      }
    }
  }

  /* 申请表单容器 */
  .application-form-container {
    width: 704px;
    padding: 36px 0;
  }

  /* 状态展示样式 */
  .application-status-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 20px;

    .status-header {
      .status-icon {
        width: 225px;
        height: 225px;
        margin: 0 auto 24px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .status-title {
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        margin-bottom: 10px;
      }

      .status-desc {
        font-size: 14px;
        color: #4e5969;
        line-height: 1.5;
        white-space: pre-wrap;
      }
    }

    .status-actions {
      display: flex;
      gap: 16px;
      justify-content: center;
      margin-top: 40px;
    }
    .file-uploadWrap {
      width: 668px;
      margin-top: 32px;
      margin-bottom: 30px;
    }
  }

  .button.primary-btn {
    width: 240px;
    font-size: 16px;
    background: #e60012;
    border-color: #e60012;
  }

  /* 响应式设计 */
  @media screen and (max-width: 768px) {
  }
</style>
